import React, { useState, useEffect } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { getNotifications, markAsRead } from "../../slices/thunks";
import SimpleBar from "simplebar-react";
import moment from "moment";
import "moment/locale/mn";

const NotificationDropdown = () => {
    const dispatch = useDispatch();
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [showModal, setShowModal] = useState(false);
    
    const { notifications } = useSelector((state) => state.Notifications || { notifications: [] });
    const authUser = JSON.parse(localStorage.getItem("authUser"));

    const toggleNotificationDropdown = () => {
        setIsNotificationDropdown(!isNotificationDropdown);
    };

    useEffect(() => {
        dispatch(getNotifications());
        const interval = setInterval(() => {
            dispatch(getNotifications());
        }, 5000); // Changed to 5 seconds for near real-time feeling
        return () => clearInterval(interval);
    }, [dispatch]);

    const handleNotificationClick = (notification) => {
        setSelectedNotification(notification);
        setShowModal(true);
        if (notification && notification.readBy && !notification.readBy.includes(authUser?._id)) {
            dispatch(markAsRead(notification._id));
        }
    };

    const getYoutubeEmbedUrl = (url) => {
        if (!url) return '';
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? 
            'https://www.youtube.com/embed/' + match[2] : url;
    };

    const currentNotifications = Array.isArray(notifications) ? notifications : [];
    const unreadNotifications = currentNotifications.filter(n => 
        n && n.readBy && !n.readBy.includes(authUser?._id)
    );

    return (
        <React.Fragment>
            <style>
                {`
                    .pro-dropdown { border-radius: 4px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); border: 1px solid #e9ebec; }
                    .pro-dropdown-header { background-color: #f3f6f9; padding: 14px 18px; border-bottom: 1px solid #e9ebec; }
                    .pro-notif-item { padding: 12px 18px; border-bottom: 1px solid #f3f6f9; transition: background-color 0.15s; }
                    .pro-notif-item:hover { background-color: #f8f9fa; }
                    .pro-notif-item.unread { background-color: #ebf4fa; }
                    .pro-notif-item.unread::before { content: ''; position: absolute; left: 0; top: 0; height: 100%; width: 3px; background-color: #3b76e1; }
                    
                    .pro-icon-bg { width: 36px; height: 36px; border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
                    .pro-icon-primary { background-color: rgba(59, 118, 225, 0.1); color: #3b76e1; }
                    .pro-icon-warning { background-color: rgba(245, 150, 0, 0.1); color: #f59600; }
                    .pro-icon-success { background-color: rgba(26, 179, 148, 0.1); color: #1ab394; }

                    .pro-modal .modal-content { border-radius: 8px; border: 1px solid #e9ebec; }
                    .pro-modal .modal-header { background-color: #ffffff; border-bottom: 1px solid #f0f0f0; padding: 16px 20px; }
                    .pro-modal .modal-body { padding: 24px 20px; background-color: #fbfcff; }
                `}
            </style>

            <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-dark rounded-circle shadow-none">
                    <i className='bx bx-bell fs-22'></i>
                    {unreadNotifications.length > 0 && (
                        <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                            {unreadNotifications.length}
                            <span className="visually-hidden">Уншаагүй мэдэгдэл</span>
                        </span>
                    )}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0 pro-dropdown">
                    <div className="pro-dropdown-header">
                        <Row className="align-items-center">
                            <Col>
                                <h6 className="m-0 fs-15 fw-semibold text-dark">Мэдэгдлүүд</h6>
                            </Col>
                            <Col className="col-auto">
                                <span className="badge badge-soft-primary fs-11 px-2 py-1">
                                    {unreadNotifications.length} шинэ
                                </span>
                            </Col>
                        </Row>
                    </div>

                    <SimpleBar style={{ maxHeight: "320px", backgroundColor: "#ffffff" }}>
                        {currentNotifications.length > 0 ? (
                            currentNotifications.map((item, index) => {
                                const isUnread = item && item.readBy && !item.readBy.includes(authUser?._id);
                                let iconProps = "pro-icon-primary bx bx-bell";
                                if (item.type === "system") iconProps = "pro-icon-warning bx bx-cog";
                                if (item.type === "alert") iconProps = "pro-icon-success bx bx-check-shield";

                                return (
                                    <div 
                                        key={index} 
                                        className={`text-reset pro-notif-item d-block dropdown-item position-relative ${isUnread ? 'unread' : ''}`}
                                        onClick={() => handleNotificationClick(item)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="d-flex align-items-start">
                                            <div className={`pro-icon-bg me-3 ${iconProps.split(' ')[0]}`}>
                                                <i className={iconProps.split(' ').slice(1).join(' ')}></i>
                                            </div>
                                            <div className="flex-grow-1 overflow-hidden">
                                                <h6 className={`mt-0 mb-1 fs-14 text-truncate ${isUnread ? 'fw-semibold text-dark' : 'fw-medium text-body'}`}>
                                                    {item.title}
                                                </h6>
                                                <div className="fs-13 text-muted text-truncate w-100 mb-1">
                                                    {item.message}
                                                </div>
                                                <p className="mb-0 fs-11 text-muted d-flex align-items-center">
                                                    <i className="mdi mdi-clock-outline me-1"></i>
                                                    {moment(item.createdAt).fromNow()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center py-5">
                                <div className="avatar-sm mx-auto bg-light rounded-circle d-flex align-items-center justify-content-center mb-3">
                                    <i className="bx bx-bell-off fs-22 text-muted"></i>
                                </div>
                                <h5 className="fs-14 fw-medium text-dark mb-1">ХООСОН</h5>
                                <p className="text-muted fs-12 mb-0">Танд мэдэгдэл алга байна.</p>
                            </div>
                        )}
                    </SimpleBar>
                </DropdownMenu>
            </Dropdown>

            <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered size="md" className="pro-modal">
                <ModalHeader toggle={() => setShowModal(false)} className="pro-modal-header">
                    <span className="fs-16 fw-semibold text-dark">{selectedNotification?.title}</span>
                </ModalHeader>
                <ModalBody className="pro-modal-body">
                    {selectedNotification && (
                        <>
                            {selectedNotification.image && (
                                <div className="mb-4 text-center">
                                    <img src={selectedNotification.image} alt="notification" className="img-fluid rounded border" />
                                </div>
                            )}
                            {selectedNotification.videoLink && (
                                <div className="ratio ratio-16x9 mb-4 rounded border overflow-hidden">
                                    <iframe 
                                        src={getYoutubeEmbedUrl(selectedNotification.videoLink)} 
                                        title="video" 
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            )}
                            
                            <div className="card shadow-none border mb-0 bg-white">
                                <div className="card-body p-3">
                                    <p className="fs-14 text-body mb-3 lh-base">
                                        {selectedNotification.message}
                                    </p>
                                    
                                    <div className="border-top pt-2 mt-2 d-flex justify-content-between align-items-center">
                                        <span className="text-muted fs-12 d-flex align-items-center">
                                            <i className="mdi mdi-calendar-blank me-1"></i>
                                            {moment(selectedNotification.createdAt).format("YYYY-MM-DD HH:mm")}
                                        </span>
                                        {selectedNotification.type && (
                                            <span className="badge bg-light text-body border text-uppercase">
                                                {selectedNotification.type}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default NotificationDropdown;